import { connect } from "react-redux"

import {
  addAssetFilter,
  removeAssetFilter,
  clearAssetFilters,
} from "../../store"
import AssetFilters from "."

const mapDispatchToProps = dispatch => ({
  onChange: event => {
    if (event.target.checked) {
      dispatch(addAssetFilter(event.target.value))
      /* istanbul ignore next */
      if (window.gtag !== undefined) {
        /* istanbul ignore next */
        window.gtag("event", "AssetFilters", {
          category: "AssetFilters",
          action: "selectAssetFilter",
          label: event.target.value,
        })
      }
    } else {
      dispatch(removeAssetFilter(event.target.value))
    }
  },
  onReset: () => {
    dispatch(clearAssetFilters())
  },
})

const mapStateToProps = ({ assetFilters }) => ({
  selectedAssetFilters: assetFilters && assetFilters.selectedAssets,
})

const AssetFiltersWithStore = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetFilters)

export default AssetFiltersWithStore
